import styled from '@emotion/styled';

import { Z_INDEX } from '@/constants/zIndex';

/** 카테고리 헤더를 플랜 헤더 바로 아래에 2단으로 고정하기 위해 높이를 공유한다. */
const HEAD_HEIGHT = 56;

/**
 * 스크롤 주체. position: sticky는 가장 가까운 스크롤 조상을 기준으로 하므로
 * 이 컨테이너가 반드시 스크롤을 담당해야 헤더 고정이 동작한다.
 */
export const ScrollArea = styled.div`
  overflow: auto;
  width: 100%;
  min-height: 0;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 8px;
`;

export const Table = styled.table`
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    padding: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
    text-align: center;

    transition: background-color 0.15s ease-in-out;
    vertical-align: middle;

    /* 셀 값에 넣은 개행(\n)을 그대로 살린다. */
    white-space: pre-line;
    word-break: keep-all;
  }

  tbody tr:hover td:not(.is-highlighted),
  tbody tr:hover th:not(.is-highlighted) {
    background-color: ${({ theme }) => theme.colors.zinc_50};
  }

  .is-highlighted {
    background-color: ${({ theme }) => theme.colors.skyblue_50};
  }
`;

/** 좌측 기능명 열. 가로 스크롤 시에도 라벨이 보이도록 고정한다. */
export const RowHeadCell = styled.th`
  position: sticky;
  z-index: ${Z_INDEX.planMatrixStickyColumn};
  left: 0;

  width: 40%;
  min-width: 220px;
  background-color: ${({ theme }) => theme.colors.white};
  text-align: left;

  ${({ theme }) => theme.mediaQuery.tablet} {
    min-width: 160px;
  }
`;

export const HeadCell = styled.th`
  position: sticky;
  z-index: ${Z_INDEX.planMatrixStickyHeader};
  top: 0;

  width: 15%;
  height: ${HEAD_HEIGHT}px;
  background-color: ${({ theme }) => theme.colors.white};

  &.is-highlighted {
    box-shadow: inset 0 2px 0 ${({ theme }) => theme.colors.skyblue_400};
  }
`;

/** 좌상단 모서리. 세로·가로 양방향으로 고정되므로 가장 위에 온다. */
export const HeadCornerCell = styled(HeadCell)`
  z-index: ${Z_INDEX.planMatrixStickyCorner};
  left: 0;
  width: 40%;
  min-width: 220px;

  ${({ theme }) => theme.mediaQuery.tablet} {
    min-width: 160px;
  }
`;

/** 카테고리 구분 행. 표가 길어 플랜 헤더 바로 아래에 2단으로 고정한다. */
export const CategoryHeadCell = styled.th`
  position: sticky;
  z-index: ${Z_INDEX.planMatrixCategoryHeader};
  top: ${HEAD_HEIGHT}px;
  left: 0;

  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.zinc_50};
  text-align: left;
`;

export const LabelCell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
